<template>
  <small v-if="type === 'small'">
    <i class="icon icon-truck"></i>
    &nbsp;
    <span v-if="$store.getters.getFutureDate.use"
      >ab {{ $store.getters.getFutureDate.val }}</span
    >
    <DeliveryTimeInner v-else :time="time" />
  </small>

  <div v-else-if="type === 'divB'">
    <i class="icon icon-truck" :data-time-days="time"></i>
    {{ $store.getters.getSelectedQty }} Stück
    <DeliveryTimeInner :time="time" />
  </div>

  <li v-else-if="type === 'li'">
    <i class="icon icon-truck"></i>
    {{ $store.getters.getSelectedQty }} Stück
    <DeliveryTimeInner :time="time" />
  </li>

  <li v-else-if="type === 'lis'">
    <span v-if="$store.getters.getFutureDate.use"
      >ab {{ $store.getters.getFutureDate.val }}</span
    >
    <DeliveryTimeInner v-else :time="time" />
  </li>
</template>

<script>
import DeliveryTimeInner from '@/components/Common/DeliveryTimeInner';

export default {
  name: 'DeliveryTime',
  props: {
    type: {
      type: String,
      default: '',
    },
    time: {
      type: Number,
      default: 0,
    },
  },
  components: {
    DeliveryTimeInner,
  }
};
</script>
